<template>
    <div class="information-details">
        <home-nav></home-nav>
        <div class="information-nav">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: cate_id == 1 ? '/information' : '/informationcharter' }">{{ cate_id == 1 ? '旅游包车资讯' : '大巴包车资讯' }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="information-box">
            <div class="information-box-left">
                <div class="information-article-top">
                    <h1 class="information-article-title">
                        {{ title }}
                    </h1>
                    <div class="information-article-info">
                        <div class="article-info-name">
                            <img src="@/assets/images/information/news_icon_ren.png" alt="">
                            <span>{{ author }}</span>
                        </div>
                        <div class="article-info-name">
                            <img src="@/assets/images/information/news_icon_ril.png" alt="">
                            <span>{{ created_at }}</span>
                        </div>
                    </div>
                </div>

                <div class="information-article-content">
                    <div v-html="content"></div>
                </div>

                <div class="information-box-label">
                    <div class="information-box-label-list" v-for="(item,index) in signArr" @click="keyWordClick(item)">
                        {{ item }}
                    </div>
                </div>

                <div class="information-pre-next-box">
                    <div class="information-pre-next">
                        <div class="information-pre">
                            <span class="information-pre-title">上一篇</span>
                            <span class="information-pre-content" @click="preClick()">{{ pre_title }}</span>
                        </div>
                        <div class="information-next">
                            <span class="information-pre-title">下一篇</span>
                            <span class="information-pre-content" @click="nextClick()">{{ next_title }}</span>
                        </div>
                    </div>
                    <div class="information-pre-right" @click="backPrePage()">
                        <img src="@/assets/images/information/icon_return.png" alt="">
                        <span>返回列表</span>
                    </div>
                </div>
            </div>
            <div class="article-right">
                <div class="article-right-search">
                    <el-input
                            placeholder="请输入内容"
                            suffix-icon="el-icon-search"
                            v-model="input2">
                    </el-input>
                </div>
                <div class="article-right-future">
                    <p class="article-right-future-p">
                        <span class="article-right-future-span">推荐新闻</span>
                        <span class="article-right-future-span-two" @click="toSeeMore()">查看更多</span>
                    </p>
                    <ul class="article-right-future-ul">
                        <li class="article-right-future-li"
                            v-for="(item,index) in recommendList"
                            :key="index"
                            @click="articleClick(item.id,item.cate_id)"
                        >
                            <div class="li-title">
                                · {{ item.title }}
                            </div>
                            <div class="li-time">
                                {{ item.created_at }}
                            </div>
                        </li>
                    </ul>
                </div>


                <div class="article-right-future">
                    <p class="article-right-future-p">
                        <span class="article-right-future-span">热点资讯</span>
                        <span class="article-right-future-span-two" @click="toSeeMore()">查看更多</span>
                    </p>
                    <ul class="article-right-future-ul">
                        <li class="article-right-future-li"
                            v-for="(item,index) in recommendList"
                            :key="index"
                            @click="articleClick(item.id,item.cate_id)"
                        >
                            <div class="li-title">
                                · {{ item.title }}
                            </div>
                            <div class="li-time">
                                {{ item.created_at }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!--底部-->
        <home-footer></home-footer>
    </div>
</template>

<script>
    import homeNav from '@/components/homeNav';
    import homeFooter from '@/components/homeFooter';

    export default {
        name: "informationDetails",
        components: {
            homeNav,
            homeFooter
        },
        data() {
            return {
                input2: '',
                article_id: '',
                title: '',
                author: '',
                created_at: '',
                content: '',
                cate_id: '',
                pre_title: '',
                pre_article_id: '',
                next_title: '',
                next_article_id: '',
                signArr: [],
                recommendList: []
            }
        },
        created() {
            var that = this;
            var pm = that.$route.params.cidgid.slice(0,-5);
            var str = pm.split("_");
            //console.log(str[1]);
            //console.log(pm);
            that.article_id = str[0];
            that.cate_id = str[1];
            //that.article_id = that.$route.param.query.id;
            //that.cate_id = that.$route.query.cate_id;
        },

        watch: {
            $route(to,form){
                this.$router.go(0)
            }
        },

        mounted() {
            var that = this;
            that.getInfomationDetail();
            that.getInfomationTwo();
            window.scrollTo(0, 0);
        },

        methods: {
            getInfomationDetail() {
                var that = this;
                /*var index;
                layui.use('layer', function () {
                    var layer = layui.layer;
                    index = layer.load(1, {
                        shade: [0.1, '#fff'] //0.1透明度的白色背景
                    });
                });*/
                that.$axios.post("/informationDetail", {
                    article_id: that.article_id,
                    cate_id: that.cate_id,
                }).then((res) => {
                    res = res.data;
                    if (res.status == 200) {
                        // layer.closeAll();
                        that.title = res.data.title;
                        that.author = res.data.author;
                        that.created_at = res.data.created_at;
                        that.content = res.data.content;
                        that.signArr = res.data.sign;
                        that.pre_title = res.data.pre_title;
                        that.pre_article_id = res.data.pre_article_id;
                        that.next_title = res.data.next_title;
                        that.next_article_id = res.data.next_article_id;
                    } else {
                        // layer.closeAll();
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    // layer.closeAll();
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },

            preClick() {
                var id = this.pre_article_id;
                var cate_id = this.cate_id;
                var pre_title = this.pre_title;
                if (pre_title == '没有上一篇了') {
                    return;
                }
                var cidgid=id+"_"+cate_id;
                console.log(cidgid)
                this.$router.push({name:"InformationDetails",params:{cidgid:cidgid+".html"}});

                // this.$router.push({path: "/informationDetails", query: {id: id, cate_id: cate_id}})
            },
            nextClick() {
                var id = this.next_article_id;
                var cate_id = this.cate_id;
                var next_title = this.next_title;
                if (next_title == '没有下一篇了') {
                    return;
                }

                var cidgid=id+"_"+cate_id;
                console.log(cidgid)
                this.$router.push({name:"InformationDetails",params:{cidgid:cidgid+".html"}});

                // this.$router.push({path: "/informationDetails", query: {id: id, cate_id: cate_id}})
            },

            // 返回列表
            backPrePage(){
                if(this.cate_id && this.cate_id == 1){
                    this.$router.push({ path: '/information' })
                } else if (this.cate_id && this.cate_id == 2){
                    this.$router.push({ path: '/informationcharter' })
                }
            },

            getInfomationTwo() {
                var that = this;
                that.$axios.post("/informationList", {
                    cate_id: 2,
                    page: 1,
                    sign_text: this.input2,
                }).then((res) => {
                    // console.log(res);
                    res = res.data;
                    if (res.status == 200) {
                        that.recommendList = res.data.data.slice(0,5);
                    } else {
                        // layer.msg(res.message, {icon: 2});
                        this.$message(res.message);
                    }//请求成功返回的数据
                }).catch((error) => {
                    /*layer.msg('系统错误', {
                        icon: 2
                    });*/
                    this.$message('系统错误');
                });
            },

            // 关键词点击
            keyWordClick(word){
                if(this.cate_id && this.cate_id == 1){
                    this.$router.push({name: "Information", params: {word: word}})
                } else if (this.cate_id && this.cate_id == 2){
                    this.$router.push({name: "Informationcharter", params: {word: word}})
                }
            },

            articleClick(id, cate_id) {
                var cidgid=id+"_"+cate_id;
                // console.log(cidgid)
                this.$router.push({name:"InformationDetails",params:{cidgid:cidgid+".html"}});

                // this.$router.push({path: "/informationDetails", query: {id: id, cate_id: cate_id}});
            },

            // 查看更多
            toSeeMore(){
                this.$router.push({name: "Information"})
            }
        },
    }
</script>

<style scoped>
    @import './informationDetails.css';
</style>



// WEBPACK FOOTER //
// src/pages/informationDetails/informationDetails.vue